var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 17.5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5zm0-5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5zm0-5h14a.75.75 0 0 0 0-1.5h-14a.75.75 0 0 0 0 1.5z"
  })));
};
export default SvgHamburgerMenu;